
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1438.54 1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M881.89 690c-270.68-14.11-198.46-39.65-448.64-20.45-207.59 15.93-362.4-33.94-428-33-262.17 3.59-597.54 120.87-605.62 123.79-227.4 82.11 2501.67 142.79 3481.79 135.17V686.38C2634 725.66 1359.05 714.88 881.89 690z","fill":"#e5eec9"}}),_c('path',{attrs:{"d":"M0 762.72l748 17.95a950.79 950.79 0 01116.45 8.18l587.75 77.8c-203.55 5.33-586 69.43-1050.5 69.51-1537.52.28-4060-83.28-4698.65-80.87-831.57 3.15-1488.29-52.62-1488.29-52.62s313.32-40.58 861.61-36.19 928.24-18 1348.6-10.4 696.94 7.25 696.94 7.25l294-35.39a730.9 730.9 0 01133-3.8l535.63 35.55q15.21 1 30.45 1.21l445 1.82H0","fill":"#80bbde"}}),_c('path',{attrs:{"d":"M0 824c-318.24 3.16-845 .08-1438.91 0-1366.48-.2-3084.17 1-3404.51 27.17-142 11.61-696.57-15.57-1004.39 4.4S-6355.7 842.2-6602 835.33s-514.36 41.78-760.61 43.22-593.77-16.38-1086.28-23-946.53-20.19-946.53-20.19c-364.78 0-566.79 107-686.82 117.33v72.2l12963.66 1v-157.7c-1.09.11-1428.14-1.64-1429.23-1.54C1352.09 876.37 127.82 824 0 824","fill":"#c5e567"}})])
          )
        }
      }
    